// oxlint-disable sorare/no-unused-fragment-fields
import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { deckFragments_deck } from './__generated__/fragments.graphql.ts';

export const deckFragment = gql`
  fragment deckFragments_deck on Deck {
    id
    slug
    name
    visible
    sport
    tokensCount
  }
` as TypedDocumentNode<deckFragments_deck>;
